/**
 * Test if the current env is a dev env.
 * @returns {boolean}
 */
export const isDev = () => window.location.hostname !== 'www.parceltinyhouse.com';

export default {
  isDev,
};
